import React, { useMemo } from "react";
import { ActionGroup, SelectableAction } from "shared-ts-ui-action";
import { LocationCityRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useMunicipalityContext } from "./MunicipalityContextProvider";

export const useMunicipalityActionGroup = (): ActionGroup => {
  const { t } = useTranslation("firefly-shared-ts-domain");
  const {
    municipalities,
    municipality: municipalityId,
    setMunicipality,
  } = useMunicipalityContext();
  return useMemo(() => {
    return {
      type: "ActionGroup",
      icon: <LocationCityRounded />,
      name: t("Municipality"),
      hide: municipalities.length === 0,
      preferences: {
        displayInline: false,
        hideGroupNodeSelected: false,
      },
      items: [
        {
          type: "Action",
          selectable: true,
          name: t("All"),
          onExecute: () => {
            setMunicipality(undefined);
          },
          selected: municipalityId == null,
        } as SelectableAction,
        ...municipalities.map((currMunicipality) => {
          return {
            type: "Action",
            selectable: true,
            name: `${currMunicipality.name} (${currMunicipality.id})`,
            reference: currMunicipality.id,
            onExecute: () => {
              setMunicipality(currMunicipality.id);
            },
            selected: currMunicipality.id === municipalityId,
          } as SelectableAction;
        }),
      ],
    } as ActionGroup;
  }, [municipalities, municipalityId, setMunicipality, t]);
};
